import { UPDATE_ENTRY_STRATEGY, UPDATE_ENTRY_STRATEGY_FAILURE, UPDATE_ENTRY_STRATEGY_SUCCESS } from './actionTypes';

const initialState = {
  loadingUpdateEntryStrategy: false,
  updateEntryStrategyError: null,
  messageUpdateEntryStrategy: null,
  entryStrategyUpdated: null,
};

const updateEntryStrategy = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_ENTRY_STRATEGY:
      state = {
        ...state,
        loadingUpdateEntryStrategy: true,
        updateEntryStrategyError: null,
        entryStrategyUpdated: null,
      };
      break;
    case UPDATE_ENTRY_STRATEGY_SUCCESS:
      state = {
        ...state,
        loadingUpdateEntryStrategy: false,
        messageUpdateEntryStrategy: action.payload.message,
        updateEntryStrategyError: null,
        entryStrategyUpdated: action.payload,
      };
      break;
    case UPDATE_ENTRY_STRATEGY_FAILURE:
      state = {
        ...state,
        loadingUpdateEntryStrategy: false,
        messageUpdateEntryStrategy: null,
        updateEntryStrategyError: action.payload,
        entryStrategyUpdated: null,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default updateEntryStrategy;
